/**
 * ver2(gold) 레이아웃 공용 값.
 *   기준 화면: gold8.bet PC(www) · 모바일(m) — 2026-10-16 캡처·저장 HTML 의 CSS 실측값.
 *   PC 원본은 본문(.homePage·#news)을 transform: scale(1.2) 로 키워 보여준다.
 *   여기서는 scale 없이 1.2 배 한 값을 직접 쓴다(마우스 위치·선명도 문제 없음).
 */
import headerBg from '@/assets/image/gold/header_bg.jpg'

export const G = {
  bg: '#0f1923',          // 페이지 바탕
  panel: '#1a242d',       // 공지 띠·하단·로그인 창
  panel2: '#262f37',      // 언어 상자
  line: '#313a44',
  gold: '#ffef77',        // 강조(로그인 버튼·선택)
  goldText: '#f2d171',    // 공지 글자
  sand: '#a8a17f',        // 하단 글자·입력칸 글자
  tileBorder: '#ffff88',  // 게임사 타일 테두리(#ff8)
  muted: '#575e65',       // LOGOUT 글자

  // 모바일(m.gold8.bet)
  mBg: '#1c1c1e',
  mPanel: '#2b2e34',
  mRed: '#e8193c',
}

/** PC 본문 폭 — 원본 1200px × 1.2 */
export const PC_WIDTH = 1440

/** 헤더 높이(원본 97px, 배경 그림 포함) */
export const PC_HEADER_H = 97

/** 헤더 금색 배경 — gold 원본 headerBg.jpg(1920×97) */
export const HEADER_BG = `url(${headerBg}) center top / cover no-repeat`

/** 입구 버튼(スロット/ライブ) 금색 */
export const ENTRANCE_BG = 'linear-gradient(to left, #cc7f2d, #fff07b, #cc7f2d)'
